import React from 'react'
import DesignerRework from './packages/@slerp/designer-rework'

const SlerpDesignerRework: React.FC = () => {
  return <DesignerRework />
}

export default SlerpDesignerRework
